import { render, staticRenderFns } from "./webmessage.vue?vue&type=template&id=6b3a836a&scoped=true&"
import script from "./webmessage.vue?vue&type=script&lang=js&"
export * from "./webmessage.vue?vue&type=script&lang=js&"
import style0 from "./webmessage.vue?vue&type=style&index=0&id=6b3a836a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../relationlistwidget/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3a836a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/dvl/tthomsen/compiere-all/pharmanord2011/template/webapps/relationlistwidget/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b3a836a')) {
      api.createRecord('6b3a836a', component.options)
    } else {
      api.reload('6b3a836a', component.options)
    }
    module.hot.accept("./webmessage.vue?vue&type=template&id=6b3a836a&scoped=true&", function () {
      api.rerender('6b3a836a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "globalComponents/webmessage.vue"
export default component.exports